import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=272f7e6e&scoped=true&lang=pug"
import script from "./Sidebar.js?vue&type=script&lang=js&external"
export * from "./Sidebar.js?vue&type=script&lang=js&external"
import style0 from "./Sidebar.sass?vue&type=style&index=0&id=272f7e6e&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272f7e6e",
  null
  
)

export default component.exports